export default {
      id: "ic-nav-close-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-close-usage",
      toString: function () {
        return this.url;
      }
    }